<template>
  <div>
    <v-card style="border-radius: 30px;">
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 lg6 style="padding: 15px 15px 0px 15px; font-size: 18px;">Route Wise Mapping</v-flex>
          <v-flex xs12 sm12 md12 lg2 style="padding: 15px 15px 0px 15px"></v-flex>
        </v-layout>
        <v-layout row wrap style="display: flex; align-content: center; align-items: center;">
          <v-flex xs12 sm12 md12 lg4 style="margin-top: -17px;">
            <v-autocomplete
                label="Start typing to search Route"
                v-model="filters.search"
                :items="routeList"
                item-value="name"
                item-text="name"
                :loading="isLoading"
                chips clearable
                name="name"
                :search-input.sync="search_name" solo flat
                style="padding-top: 24px; margin-top: 0px;"
            ></v-autocomplete>
<!--            <v-text-field-->
<!--                v-model="filters.search"-->
<!--                append-icon="search"-->
<!--                label="Search"-->
<!--                single-line-->
<!--                hide-details-->
<!--                clearable-->
<!--                solo-->
<!--                :search-input.sync="search_name"-->
<!--                v-on:keyup.enter="getRouteWiseMappedData()"-->
<!--            ></v-text-field>-->
          </v-flex>
          <v-flex xs12 sm12 md12 lg3></v-flex>
          <v-flex xs12 sm12 md6 lg4 style="float: right; padding: 15px 15px 0px 0px">
            <v-menu
                v-model="route_wise_date_menu"
                :close-on-content-click="false"
                :nudge-right="-200"
                transition="scale-transition"
                offset-x
                min-width="auto"
                style="padding-top: 10px;"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="filters.route_wise_filter_date"
                    label="Date"
                    readonly
                    v-bind="attrs"
                    v-on="on" clearable solo
                    v-on:change="getRouteWiseMappedData()"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="filters.route_wise_filter_date"
                  @input="route_wise_date_menu = false"
                  :max="current_date"

              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>


        <v-flex xs12 sm12 md12 lg12>
          <v-data-table
              :headers="headers"
              :items="mappedData"
              class="elevation-1"
              :pagination.sync="pagination"
              :total-items="total_items"
              :loading="loader1"
              :rows-per-page-items="[5, 10, 20, 100]"
              no-results-text="Loading... Please wait"
          >
            <template v-slot:items="props">
              <td>{{ props.item.name }}</td>
              <td v-if="filters.route_wise_filter_date == current_date">{{ props.item.journey_ongoing }}</td>
              <td v-else>{{ " - " }}</td>

              <td v-if="filters.route_wise_filter_date == current_date">{{ props.item.journey_completed }}</td>
              <td v-else>{{ " - " }}</td>

              <td v-if="filters.route_wise_filter_date != current_date">{{ props.item.missed_trains }}</td>
              <td v-else>{{ " - " }}</td>

              <td>{{ props.item.mapped_trains }}</td>

              <td>{{ props.item.total_trains }}</td>

              <td v-if="filters.route_wise_filter_date != current_date">{{ props.item.percentage + " %" }}</td>
              <td v-else>{{ " - " }}</td>
            </template>
<!--            <template v-slot:no-results>-->
<!--              <v-alert :value="true" color="error" icon="warning">-->
<!--                Your search for "{{ search }}" found no results.-->
<!--              </v-alert>-->
<!--            </template>-->
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>


    <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
      {{ snackbar.message }}
      <v-btn
          text
          dark
          @click="snackbar.display = false"
      >
        <v-icon
            right
            color="white"
        >
          close
        </v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "RouteWiseMappingReportDashboard",
  watch: {
    pagination: {
      handler() {
        this.getRouteWiseMappedData();
      }
    },
    "filters.route_wise_filter_date" : function (val){
      if(val){
        this.getRouteWiseMappedData();
      }
    },
    search_name: function(val){
      if (val != null && val.length >= 2) {
        this.isLoading = true;
        this.getRouteList();
      }

      if(val == undefined){
        this.getRouteWiseMappedData();
      }
    },
  },
  data(){
    return{
      route_wise_date_menu: false,
      filters:{
        search: 'All',
        route_wise_filter_date: moment().format('YYYY-MM-DD'),
      },
      headers: [
        { text: 'Name', value: "name", align: 'left', sortable: false},
        { text: 'Ongoing', align: 'left', sortable: false, value:'journey_ongoing' },
        { text: 'Completed',align: 'left', value: 'journey_completed' },
        { text: 'Missed', value: 'missed', sortable: false },
        { text: 'Mapped', value: 'mapped', sortable: false },
        { text: 'Total', value: 'total', sortable:false },
        { text: 'Mapping (%)', value: 'percentage', sortable: true }
      ],
      mappedData: [],
      pagination: { sortBy: "percentage", descending: true, rowsPerPage: 10 },
      loader: false,
      loader1: false,
      total_items: 0,
      search: '',
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000
      },
      current_date: '',
      search_name: 'All',
      isLoading: false,
      routeList: []
    }
  },
  methods:{
    getRouteWiseMappedData(){
      this.loader1 = true;
      this.pagination.filters = Object.assign({}, this.filters);
      this.mappedData = [];

      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-route-wise-mapping-data`, { params:
        this.pagination, headers: this.$headers}).then(response => {
        if (response.data.status == 1) {
          this.loader1 = false;
          this.mappedData = response.data.data.data;
          this.total_items = response.data.data.total;
        }else{
          this.loader1 = false;
        }
      }).catch((error) => {
        // console.log(error);
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true;
      });
    },
    getRouteList(){
      this.loader = true;
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-route-list`, {headers: this.$headers}).then(response => {
        if (response.data.status == 1) {
          this.isLoading = false;
          this.routeList = response.data.data;
          this.routeList.push({id : 'All', name: 'ALL'})

          this.loader = false;
        }else if(response.data.status == 0){
          this.loader = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      }).catch((error) => {
        this.loader = false;
        this.snackbar.message = "Something went wrong";
        this.snackbar.display = true;
      });
    },
  },
  mounted() {
    this.current_date = moment().format('YYYY-MM-DD');
  }
}
</script>

<style scoped>

</style>
